import {Component, Input, OnChanges, OnDestroy} from '@angular/core';
import {UntypedFormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {CustomFieldType} from '@ee/common/enums';
import {CaseSettings} from '@ee/common/models';

@Component({
  selector: 'ee-court-judgement',
  template: `
    @if (!!form) {
      <div [formGroup]="form" class="flex flex-col justify-start items-stretch">
        <div class="in-row-grid wider" [ngClass]="{'mb-2': !forceVertical}">
          @if (caseSettings?.judgement_options?.length) {
            <mat-form-field class="compact white" [ngClass]="{'w-full mb-4': forceVertical}" appearance="outline">
              <mat-label>Judgment</mat-label>
              <mat-select formControlName="judgement">
                @for (option of caseSettings.judgement_options; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                }
              </mat-select>
              <mat-hint>{{form?.get('judgement').hasValidator(Validators.required) ? 'Required' : 'Optional'}}</mat-hint>
            </mat-form-field>
          }
          <mat-form-field class="compact white" [ngClass]="{'w-full mb-4': forceVertical}" appearance="outline">
            <mat-label>Judgment Amount</mat-label>
            <span matPrefix>$ &nbsp;</span>
            <input matInput type="number" formControlName="judgement_amount">
            <mat-hint>{{form?.get('judgement_amount').hasValidator(Validators.required) ? 'Required' : 'Optional'}}</mat-hint>
          </mat-form-field>
        </div>
        <div class="in-row-grid wider" [ngClass]="{'mb-2': !forceVertical}">
          <mat-form-field class="compact white" [ngClass]="{'w-full mb-4': forceVertical}" appearance="outline">
            <mat-label>Judgment Date</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="judgement_date">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-hint>{{form?.get('judgement_date').hasValidator(Validators.required) ? 'Required' : 'Optional'}}</mat-hint>
          </mat-form-field>
          @if (caseSettings?.court_result_options?.length) {
            <mat-form-field class="compact white" appearance="outline"
              [ngClass]="{'w-full mb-4': forceVertical}">
              <mat-label>Docket Result</mat-label>
              <mat-select formControlName="court_result">
                @for (option of caseSettings.court_result_options; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                }
              </mat-select>
              <mat-hint>{{form?.get('court_result').hasValidator(Validators.required) ? 'Required' : 'Optional'}}</mat-hint>
            </mat-form-field>
          }
        </div>
        @if (!hideComment) {
          <div>
            <mat-form-field class="compact white" [ngClass]="{'w-full': forceVertical}" appearance="outline">
              <mat-label>Comment</mat-label>
              <textarea matInput rows="4" formControlName="comment"></textarea>
              @if (form?.get('comment').hasError('required')) {
                <mat-error>
                  Please provide a reason for the change.
                </mat-error>
              }
              <mat-hint>Optional</mat-hint>
            </mat-form-field>
          </div>
        }
      </div>
    }
    `,
  styles: [`
    .mat-mdc-text-field-wrapper {
      background-color: var(--color-surface, #fff);
    }

    :host-context(.dark-theme) {
      .mat-mdc-text-field-wrapper {
        background-color: #3d3d3d !important;
      }

      .mat-mdc-form-field {
        .mdc-floating-label {
          color: rgba(255, 255, 255, 0.7) !important;
        }

        input, textarea {
          color: rgba(255, 255, 255, 0.87) !important;
        }

        .mat-mdc-form-field-hint {
          color: rgba(255, 255, 255, 0.5) !important;
        }

        .mat-mdc-select-value {
          color: rgba(255, 255, 255, 0.87) !important;
        }

        .mat-mdc-select-arrow {
          color: rgba(255, 255, 255, 0.7) !important;
        }
      }

      // Prefix styling
      [matPrefix] {
        color: rgba(255, 255, 255, 0.7) !important;
      }
    }
  `],
  standalone: false
})
export class CourtJudgementComponent implements OnChanges, OnDestroy {
  @Input() caseSettings: CaseSettings | null;
  @Input({required: true}) form: UntypedFormGroup;
  @Input() forceVertical = false;
  @Input() hideComment = false;
  public name: string;

  subs: Subscription[] = [];

  constructor() {
  }

  ngOnChanges() {
    if (this.form && this.caseSettings?.judgement_options?.length) {
      this.form?.get('judgement').setValue(this.caseSettings.judgement_options[0]);
    }
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

  protected readonly CustomFieldType = CustomFieldType;
  protected readonly Validators = Validators;
}
